
export const initialState ={
    isDisplayCopyContractPage:false,
    contractDetails:{},
    contractSelectedValues:{},
    priceAndServiceMapData:{},
    contractCopyRequestBody : {},
    copyContractResponse : null,
    loading:false

}